import i18n from "@i18n";
import {
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_TABLE_SECTION,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_GENERAL_FORMS,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_PERMIT_TO_WORK,
  SECTION_TYPE_CHANGE_ORDERS,
  SECTION_TYPE_BLANK_SECTION,
  SECTION_TYPE_PRESET_SECTION,
  SECTION_TYPE_SECTION_FROM_LIBRARY,
  SECTION_TYPE_CUSTOM_MODULES,
  formCategories,
} from "@Helpers";

export const formCategoriesDataSource = [
  { name: i18n.t("Inspections"), value: formCategories.inspection },
  { name: i18n.t("Progress Updates"), value: formCategories.progressUpdates },
  { name: i18n.t("General Forms"), value: formCategories.generalForms },
  { name: i18n.t("Change Orders"), value: formCategories.changeOrder },
  { name: i18n.t("Payments"), value: formCategories.payments },
  { name: i18n.t("Permit To Work"), value: formCategories.permitToWork },
  { name: i18n.t("MailBox"), value: formCategories.mailBox },
  { name: i18n.t("Bills"), value: formCategories.bills },
  { name: i18n.t("Issues"), value: formCategories.issues },
  { name: i18n.t("Projects"), value: formCategories.projects },
  { name: i18n.t("Files"), value: formCategories.files },
  { name: i18n.t("Contracts"), value: formCategories.contract },
  { name: i18n.t("Model"), value: formCategories.model },
  { name: i18n.t("Reviews"), value: formCategories.reviews },
  { name: i18n.t("Transmittals"), value: formCategories.transmittal },
];

export const formCategoryObject = {
  [formCategories.inspection]: {
    formHeader: "Inspection",
    tabTitle: "Inspections",
    activeCell: "Inspections",
    selectedTab: "inspection",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      // "linkForm",
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_TASK,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },

  [formCategories.progressUpdates]: {
    formHeader: "Progress Update",
    tabTitle: "Progress and Updates",
    activeCell: "Progress Updates",
    selectedTab: "progressUpdates",
    allowedSections: [
      // "linkForm",
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_TASK,
      SECTION_TYPE_MILESTONE,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },

  [formCategories.generalForms]: {
    formHeader: "General Form",
    tabTitle: "General Forms",
    activeCell: "General Forms",
    allowedSections: [
      // "linkForm",
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },
  [formCategories.mailBox]: {
    formHeader: "Mail Box",
    tabTitle: "Mail Box",
    activeCell: "Mailbox",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.bills]: {
    formHeader: "Bill",
    selectedTab: "bills",
    tabTitle: "Bills",
    activeCell: "Bills",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_TASK,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },
  [formCategories.changeOrder]: {
    formHeader: "Change Order",
    selectedTab: "changeOrders",
    tabTitle: "Change Order",
    activeCell: "Change Orders",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SUMMARY_OF_CHANGES,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },
  [formCategories.payments]: {
    formHeader: "Payments",
    selectedTab: "payments",
    tabTitle: "Payments",
    activeCell: "Payments",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
    ],
  },
  [formCategories.permitToWork]: {
    formHeader: "Permit To Work",
    selectedTab: "PermitToWork",
    tabTitle: "Permit To Work",
    activeCell: "Permit To Work",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
      SECTION_TYPE_GENERAL_FORMS,
      SECTION_TYPE_PERMIT_TO_WORK,
    ],
  },
  [formCategories.issues]: {
    formHeader: "Issues",
    tabTitle: "Issues",
    activeCell: "Issues",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.projects]: {
    formHeader: "Projects",
    tabTitle: "Projects",
    activeCell: "Projects",
    formType: "projects",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
    singleTemplate: true,
    defaultSection: {
      questionFields: [
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "ID",
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Name",
        },
      ],
      sectionHeading: "ProjectDetails",
    },
  },
  [formCategories.files]: {
    formHeader: "Files",
    tabTitle: "Files",
    activeCell: "Files",
    formType: "files",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.contract]: {
    formHeader: "Contract",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.model]: {
    formHeader: "Model",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.reviews]: {
    formHeader: "review",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.transmittal]: {
    formHeader: "transmittals",
    titleLable: "Title",
    descriptionLable: "Description",
    urlKey: "forms",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    listUrlKey: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
};

export const getPresetSectionsObject = () => ({
  [SECTION_TYPE_QUANTITY]: "Quantities",
  [SECTION_TYPE_REFERENCE]: "References",
  [SECTION_TYPE_FORM]: "Forms",
  [SECTION_TYPE_TASK]: "Tasks",
  [SECTION_TYPE_MILESTONE]: "Milestones",
  [SECTION_TYPE_WBS_ITEMS]: "WBS Items",
  [SECTION_TYPE_SUMMARY_OF_CHANGES]: "Summary of Changes",
  [SECTION_TYPE_REVIEWS]: "Reviews",
  [SECTION_TYPE_INSPECTION]: "Inspections",
  [SECTION_TYPE_PROGRESS_UPDATES]: "Progress Updates",
  [SECTION_TYPE_BILLS]: "Bills",
  [SECTION_TYPE_CHANGE_ORDERS]: "Change Orders",
  [SECTION_TYPE_GENERAL_FORMS]: "General Forms",
  [SECTION_TYPE_PERMIT_TO_WORK]: "Permit to Work",
});

export const getPresetSectionsDataSource = () => {
  const presetSectionsObject = getPresetSectionsObject();
  return [
    { id: SECTION_TYPE_QUANTITY, text: presetSectionsObject[SECTION_TYPE_QUANTITY] },
    { id: SECTION_TYPE_REFERENCE, text: presetSectionsObject[SECTION_TYPE_REFERENCE] },
    // { id: "linkForm", text: presetSectionsObject.SECTION_TYPE_FORM, },
    { id: SECTION_TYPE_TASK, text: presetSectionsObject[SECTION_TYPE_TASK] },
    { id: SECTION_TYPE_MILESTONE, text: presetSectionsObject[SECTION_TYPE_MILESTONE] },
    { id: SECTION_TYPE_WBS_ITEMS, text: presetSectionsObject[SECTION_TYPE_WBS_ITEMS] },
    { id: SECTION_TYPE_SUMMARY_OF_CHANGES, text: presetSectionsObject[SECTION_TYPE_SUMMARY_OF_CHANGES] },
    { id: SECTION_TYPE_INSPECTION, text: presetSectionsObject[SECTION_TYPE_INSPECTION] },
    { id: SECTION_TYPE_PROGRESS_UPDATES, text: presetSectionsObject[SECTION_TYPE_PROGRESS_UPDATES] },
    { id: SECTION_TYPE_BILLS, text: presetSectionsObject[SECTION_TYPE_BILLS] },
    { id: SECTION_TYPE_REVIEWS, text: presetSectionsObject[SECTION_TYPE_REVIEWS] },
    { id: SECTION_TYPE_CHANGE_ORDERS, text: presetSectionsObject[SECTION_TYPE_CHANGE_ORDERS] },
    { id: SECTION_TYPE_GENERAL_FORMS, text: presetSectionsObject[SECTION_TYPE_GENERAL_FORMS] },
    { id: SECTION_TYPE_PERMIT_TO_WORK, text: presetSectionsObject[SECTION_TYPE_PERMIT_TO_WORK] },
  ];
};

export const presetSections = [
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_CHANGE_ORDERS,
  SECTION_TYPE_GENERAL_FORMS,
  SECTION_TYPE_PERMIT_TO_WORK,
];

export const formTemplateSource = {
  projectSettings: "project_settings",
  portalSettings: "portal_settings",
};

export const moduleIconMapper = {
  [formCategories.inspection]: "inspectionForm",
  [formCategories.progressUpdates]: "ProgressUpdates",
  [formCategories.generalForms]: "generalForms",
  [formCategories.permitToWork]: "PermitToWork",
  [formCategories.bills]: "bills",
  [formCategories.payments]: "Payments",
  [formCategories.contract]: "Contracts",
  [formCategories.files]: "files",
  [formCategories.issues]: "issues",
  [formCategories.reviews]: "Review",
  [formCategories.mailBox]: "Mailbox",
  [formCategories.model]: "Models&Drawings",
  [formCategories.changeOrder]: "changeOrder",
};
export const sectionTypeMapper = {
  [SECTION_TYPE_INSPECTION]: formCategories.inspection,
  [SECTION_TYPE_PROGRESS_UPDATES]: formCategories.progressUpdates,
  [SECTION_TYPE_BILLS]: formCategories.bills,
  [SECTION_TYPE_CHANGE_ORDERS]: formCategories.changeOrder,
  [SECTION_TYPE_GENERAL_FORMS]: formCategories.generalForms,
  [SECTION_TYPE_PERMIT_TO_WORK]: formCategories.permitToWork,
};
